import React from 'react'
import styled from 'styled-components'
import Switcher from '../Icons/Switcher/Switcher'
import { Black, Dark2, SwitchColor, WerfenColor } from '../../Constants/ColorChart'
import FeatherIconWrapper from "../Icons/FeatherIconWrapper";

/*
 *  @Description:   Stateless component that represents a true/false selector.
 */

const Wrapper = styled.div`
    padding-top: 10px;
    margin-top: -25px;
    margin-bottom: -35px;
`;


const BooleanSwitcher = ( { className, isActive, onClick } ) => (
    <Wrapper>
        <FeatherIconWrapper
            color={ Black }
            className={ className }
            fillColor={ SwitchColor }
            fillSecondaryColor={ isActive ? WerfenColor : Dark2 }
            iconStyle="stroke-width: 0px; &:hover{stroke-width:0!important}"
            width="50px"
            onClick={ onClick }
            Icon={ Switcher }
            isActive={ isActive }
        />
    </Wrapper>
);


export default BooleanSwitcher;